import apiClient from '@/plugins/axios'

export default {
  getCategorias() {
    return apiClient.get('categoria')
  },

  getCategoria(id) {
    return apiClient.get(`categoria/${id}`)
  },

  postCategoria(categoria) {
    return apiClient.post(`categoria`, { categoria })

  },

  putCategoria(id, categoria) {
    return apiClient.put(`categoria/${id}`, { categoria })

  },

  deleteCategoria(id) {
    return apiClient.delete(`categoria/${id}`)

  },

  getDropDown(id) {
    return apiClient.get(`categoria/dropdown/${id}`)
  },

}


// WEBPACK FOOTER //
// ./src/views/Categoria/_services/CategoriaService.js